import { useContext } from 'react'
import { BreadCrumbsActionsContext, BreadCrumbsContext } from '../context/breadcrumbs'

export const useBreadCrumbsData = () => useContext(BreadCrumbsContext)
export const useBreadCrumbs = () => useContext(BreadCrumbsActionsContext)
